export const trimText = (text: string, maxLength: number) =>
    text.length > maxLength ? `${text.substring(0, maxLength)}…` : text;
